import { Switch as MuiSwitch } from '@mui/material';
import { FC } from 'react';

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  accentColor?: string;
}

export const Switch: FC<SwitchProps> = ({ checked, onChange, disabled, accentColor }) => {
  const color = accentColor ?? 'var(--tg-theme-button-color)';

  return (
    <MuiSwitch
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      disabled={disabled}
      color="default"
      sx={{
        '& .MuiSwitch-switchBase.Mui-checked': {
          color,
          '& + .MuiSwitch-track': {
            backgroundColor: color,
            opacity: 0.45,
          },
        },
      }}
    />
  );
};
